/**
 * Created by kyle on 5/3/17.
 */
import Vue from 'vue'
import Vuex from 'vuex'

import * as getters from './getters'
import * as actions from './actions'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// Prepare metrics
var metrics = {
  'FCM': [],
  'TCM': [],
  'HCM': []
}

for (let i = 0; i < self.metrics.length; i++) {
  metrics[self.metrics[i].name] = self.metrics[i].metrics
}

export default new Vuex.Store({
  state: {
    selectedMetricCategory: null,
    selectionBoxMode: 'Communities',
    categories: [
      {
        'name': 'FCM',
        'display': 'Financial Capacity Metrics',
        'description': 'Developing and implementing energy projects that will make communities less dependent on imported fuels is expensive, even if projects have significant public financing. Metrics in this category focus on the existence of capital as well as local costs of doing business.',
        'id': 1,
        'showDetails': false
      },
      {
        'name': 'HCM',
        'display': 'Human Capacity Metrics',
        'description': 'Metrics in this category focus on the skills people need to develop and implement projects as well as whether there are community members with the skills to maintain projects – to ensure they can be sustained over the long term.',
        'id': 2,
        'showDetails': false
      },
      {
        'name': 'TCM',
        'display': 'Technical Capacity Metrics',
        'description': 'Communities need access to technical information to help them design energy systems that require less imported fuel. Metrics in this category focus on information on current energy use (for electricity, transportation, and heating or cooling) and basic community infrastructure.',
        'id': 3,
        'showDetails': false
      }
    ],
    communityList: self.aggregated_scores,
    communityMetrics: {},
    metrics: metrics,
    pendingCommunities: [],
    AEAEnergyRegions: self.aea_energy_regions,
    CensusAreas: self.census_areas,
    selectFilterText: ''
  },
  actions,
  getters,
  mutations: {
    metricCategory (state, newCategory) {
      state.selectedMetricCategory = newCategory
    },
    metricCategoryDetails (state, category) {
      state.categories[state.categories.indexOf(category)].showDetails = !category.showDetails
    },
    communitySelected (state, payload) {
      state.communityList[payload.index].selected = payload.selected
    },
    communityCheckbox (state, payload) {
      for (let i = 0; i < state.communityList.length; i++) {
        if (state.communityList[i].name === payload.community.name) {
          state.communityList[i].selected = !payload.community.selected
        }
      }
    },
    clearSelectedCommunities (state) {
      let cl = state.communityList
      for (let i = 0; i < cl.length; i++) {
        cl[i].selected = false
      }
      state.communityList = cl
    },
    saveCommunityMetrics (state, payload) {
      for (let communityName in payload.metrics) {
        Vue.set(state.communityMetrics, communityName, payload.metrics[communityName])
      }
    },
    queueCommunity (state, payload) {
      state.pendingCommunities.push(payload.community)
    },
    clearCommunityQueue (state) {
      state.pendingCommunities = []
    },
    communitySelectionModeChange (state, payload) {
      state.selectionBoxMode = payload.mode
    },
    aeaEnergyRegionSelection (state, payload) {
      for (let i = 0; i < state.communityList.length; i++) {
        if (state.communityList[i].aea_energy_region === payload.regionID) {
          state.communityList[i].selected = payload.selected
        }
      }
    },
    censusAreaSelection (state, payload) {
      for (let i = 0; i < state.communityList.length; i++) {
        if (state.communityList[i].census_area === payload.censusAreaID) {
          state.communityList[i].selected = payload.selected
        }
      }
    },
    selectFilterText (state, payload) {
      state.selectFilterText = payload.value
    }
  },
  strict: debug
})




// WEBPACK FOOTER //
// ./src/store/index.js